import { useState } from 'react';

import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import PropTypes from 'prop-types';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import IconButton from '@zenbusiness/zui/IconButton';
import Tooltip from '@zenbusiness/zui/Tooltip';

import { StyledButtonGroup } from './FeedbackForm.styles';
import { CLICKSTREAM_COMMON_PROPS, USER_FEEDBACK } from '../utils/constants';

const GOOD_RESPONSE_LABEL = 'Good response';
const BAD_RESPONSE_LABEL = 'Bad response';

function FeedbackForm({
  onComponentClick,
  value = USER_FEEDBACK.NEUTRAL,
  instructionId: messageUuid
}) {
  const [currentValue, setCurrentValue] = useState(value);
  const isVeloUserFeedbackEnabled = useExperimentFlag('enable-velo-user-feedback', false);

  const handleUserFeedback = (feedback) => {
    setCurrentValue(feedback);
    onComponentClick({
      type: 'user_feedback',
      payload: {
        feedback,
        messageUuid
      }
    });
  };

  if (!isVeloUserFeedbackEnabled) return null;

  const isDisabled = currentValue !== USER_FEEDBACK.NEUTRAL;

  return (
    <StyledButtonGroup aria-label="feedback options" disabled={isDisabled}>
      <IconButton
        clickstreamProps={{
          ...CLICKSTREAM_COMMON_PROPS,
          elementName: 'user_feedback',
          elementText: 'Good'
        }}
        label={GOOD_RESPONSE_LABEL}
        onClick={() => handleUserFeedback(USER_FEEDBACK.GOOD)}
      >
        <Tooltip placement="bottom" title={GOOD_RESPONSE_LABEL}>
          {currentValue === USER_FEEDBACK.GOOD ? (
            <ThumbUpAltIcon data-testid="thumbs-up-on-icon" />
          ) : (
            <ThumbUpOffAltIcon data-testid="thumbs-up-off-icon" />
          )}
        </Tooltip>
      </IconButton>
      <IconButton
        clickstreamProps={{
          ...CLICKSTREAM_COMMON_PROPS,
          elementName: 'user_feedback',
          elementText: 'Bad'
        }}
        label={BAD_RESPONSE_LABEL}
        onClick={() => handleUserFeedback(USER_FEEDBACK.BAD)}
      >
        <Tooltip placement="bottom" title={BAD_RESPONSE_LABEL}>
          {currentValue === USER_FEEDBACK.BAD ? (
            <ThumbDownAltIcon data-testid="thumbs-down-on-icon" />
          ) : (
            <ThumbDownOffAltIcon data-testid="thumbs-down-off-icon" />
          )}
        </Tooltip>
      </IconButton>
    </StyledButtonGroup>
  );
}

FeedbackForm.propTypes = {
  onComponentClick: PropTypes.func.isRequired,
  value: PropTypes.string,
  instructionId: PropTypes.string.isRequired
};

export default FeedbackForm;
